module.exports = __webpack_public_path__ + "static/media/eh.2a0e164e.svg";